module.exports = __webpack_public_path__ + "img/gigihpack-worker-printing.c6192d5d.jpg";